import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
/**
 * List all available Animations. Only gives back Animations if a Car is loaded.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEListAnimations",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateListAnimationsRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEListAnimations });
}
/**
 * Trigger animations. An animation can be skipped to one of its states.
 *
 * Message flow: One AVETriggerAnimations REQUEST will result in:
 * - At least one correlated AVETriggerAnimations UPDATE to acknowledge the start of the animation(s).
 * - One or more AVEAnimationUpdate UPDATE indicating that an animation has finished playing.
 */
export function generateTriggerAnimationsRequest({ animationIds, direction, skip, messageId }) {
    return generateRequest({
        messageId,
        name: AveRequestEvents.AVETriggerAnimations,
        data: { animationIds, direction, skip }
    });
}
/**
 * Set all animations to their initial state.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEEndAnimations",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateEndAnimationsRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEEndAnimations });
}
//# sourceMappingURL=animation.js.map